import React from 'react';
import {Loader as SemanticLoader} from 'semantic-ui-react';

export default ({inline}: {inline?: any}) => (
  <SemanticLoader role="progressbar" active inline={inline} data-testid="loader-spinner" />
);
